<template>
	<ProjectRevenueForecast :project-id="projectId" />
</template>

<script setup lang="ts">
import { ProjectRevenueForecast } from '@/features/Project';
import { type RetainerPeriod, type Project } from '@/generated/graphql';

defineProps<{
	projectId: Project['id'];
	retainerPeriodId?: RetainerPeriod['id'];
}>();
</script>
